import { Button } from '@sunwebgroup/uds-ui/button'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { Window } from '@sunwebgroup/uds-ui/window'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { getServiceName } from '../helpers/getServiceName'
import { ServiceIcon } from '../ServiceIcon'
import styles from './OptionalAncillariesWindow.module.css'

interface OptionalAncillariesWindowProps {
  ancillaries: string[]
  open: boolean
  onClose: () => void
  goToNextStep: () => void
}

function ServiceLine({ type }: { type: string }) {
  const items = useCMSPageField('Checkout.items')?.items ?? []
  const checkoutItem = items.find(item => item.aName?.includes(type))
  const intl = useIntl()

  if (!type || !checkoutItem)
    return null
  const serviceName = getServiceName(type, intl)

  return (
    <div className={styles.serviceLine}>
      <ServiceIcon type={type} size={16} />
      <Typography variant="body-m-regular-snug">
        {serviceName || checkoutItem?.optionalAncillariesPopupUnselectedServiceText || checkoutItem?.componentTitle}
      </Typography>
    </div>
  )
}

export function OptionalAncillariesWindow({ ancillaries, open, onClose, goToNextStep }: OptionalAncillariesWindowProps) {
  const intl = useIntl()

  return (
    <Window.Root open={open}>
      <Window
        className={styles.window}
        title={intl.formatMessage({ id: 'checkout_steps_next_step_modal_title' })}
        closeLabel={intl.formatMessage({ id: 'close' })}
        onCloseClick={onClose}
        hasTitleBar={false}
      >
        <Typography variant="body-m-regular-snug" as="p">
          {intl.formatMessage({ id: 'checkout_steps_next_step_modal_description' })}
        </Typography>
        <div>
          {ancillaries.map(id => (
            <ServiceLine key={id} type={id} />
          ))}
        </div>

        <div className={styles.actions}>
          <Button variant="primary" onClick={goToNextStep} data-qa="checkout-next-step-continue-button">
            {intl.formatMessage({ id: 'checkout_steps_next_step_modal_continue_button_text' })}
          </Button>
          <Button variant="transparentNeutral" onClick={onClose}>
            {intl.formatMessage({ id: 'checkout_steps_next_step_modal_cancel_button_text' })}
          </Button>
        </div>
      </Window>
    </Window.Root>
  )
}
